import { useMemo, useEffect } from "react";
import useAZZKUTopics from "hooks/AZZKU/useAZZKUTopics";
import useAZZKUVoivodeships from "hooks/AZZKU/useAZZKUVoivodeships";

import AZZKUTopResultsYear from "./components/AZZKUTopResultsYear";

export default function AZZKUTopResultsMain({ params, setHeading, onChange }) {

   const { d: topics } = useAZZKUTopics();
   const { d: voivodeships } = useAZZKUVoivodeships();

   const _heading_ = useMemo(() => {
      
      if ( !topics || !voivodeships ) return "";

      const heading = [];

      let variable_name = "";
      for ( let topic of topics ) {
         const variable = topic.variables?.find( v => +v.value === +params.variable_id );
         if ( variable ) {
            variable_name = variable.label;
            break;
         }
      }

      heading.push( variable_name );

      params.year && heading.push( params.year );

      if ( params.voivodeship_ids && !!params.voivodeship_ids.length ) {
         heading.push( params.voivodeship_ids.map( id => {
            return id === 0 ? "Cała Polska" : voivodeships.find( v => +v.value === id )?.label;
         }).join(", "));
      }

      return heading.join(" | ");
   }, [ topics, voivodeships, params.variable_id, params.year, params.voivodeship_ids ])

   useEffect(() => { setHeading( _heading_ )}, [ _heading_ ]);

   return (
      <>
         <AZZKUTopResultsYear
            params={ params }
            onChange={ onChange }
         />
      </>
   )
}